import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Alert,
  Button,
  Radio,
  Space,
  Switch,
  message,
} from 'antd';

const SCOPE_OPTIONS = [
  {
    value: 'inbox_only',
    label: 'Inbox Only',
    description: 'Auto-archive non-referral inbox records only.',
  },
  {
    value: 'rm_only',
    label: 'Referral Management Only',
    description: 'Auto-archive referral records only.',
  },
  {
    value: 'both',
    label: 'Both',
    description: 'Auto-archive both inbox and referral records.',
  },
];

const settingEnabled = (value) => value === true || value === 'true';

const AutoArchiveSettings = ({ settings, updateSettings, autoEnable }) => {
  const [enabled, setEnabled] = useState(false);
  const [scope, setScope] = useState('inbox_only');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const nextSettings = settings || {};

    setEnabled(autoEnable || settingEnabled(nextSettings.enabled));
    setScope(nextSettings.scope || 'inbox_only');
  }, [settings, autoEnable]);

  const handleSave = async () => {
    setSaving(true);

    try {
      await updateSettings({
        enabled,
        scope,
      });
      message.success('Settings saved successfully');
    } catch (error) {
      const errorMsg = error?.response?.data?.error || 'Failed to save settings';
      message.error(errorMsg);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <Alert
        type="info"
        showIcon
        message="Control whether successful EMR uploads auto-archive regular inbox records, referral records, or both."
        style={{ marginBottom: 16 }}
      />

      <div style={{ marginBottom: 16 }}>
        <Space>
          <span>Enable:</span>
          <Switch checked={enabled} onChange={setEnabled} />
        </Space>
      </div>

      {enabled && (
        <Radio.Group
          value={scope}
          onChange={(event) => setScope(event.target.value)}
          style={{ display: 'flex', flexDirection: 'column', gap: 12 }}
        >
          {SCOPE_OPTIONS.map((option) => (
            <Radio key={option.value} value={option.value} style={{ lineHeight: 1.5 }}>
              <div>
                <strong>{option.label}</strong>
              </div>
              <div style={{ color: '#666' }}>
                {option.description}
              </div>
            </Radio>
          ))}
        </Radio.Group>
      )}

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 24 }}>
        <Button type="primary" loading={saving} onClick={handleSave}>
          Save
        </Button>
      </div>
    </div>
  );
};

AutoArchiveSettings.defaultProps = {
  settings: {},
  autoEnable: false,
};

AutoArchiveSettings.propTypes = {
  settings: PropTypes.object,
  updateSettings: PropTypes.func.isRequired,
  autoEnable: PropTypes.bool,
};

export default AutoArchiveSettings;
